// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Pyd_","left":"StickyBox_left__2KGgd","right":"StickyBox_right__1cxRu"};